import { render } from "./multi-prediction.vue?vue&type=template&id=4d647486&scoped=true"
import script from "./multi-prediction.vue?vue&type=script&lang=js"
export * from "./multi-prediction.vue?vue&type=script&lang=js"

import "./multi-prediction.vue?vue&type=style&index=0&id=4d647486&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d647486"]])

export default __exports__